// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1g1Y1","title":"Images90_title__8Tah_","images":"Images90_images__3Kk2k"};